// Status do chamado (DA-099) — rotulos + cores. Cores pensadas pro daltonismo
// (sem depender de verde/vermelho; o rotulo escrito carrega o sentido).
export type StatusChamado = 'aberto' | 'encaminhado' | 'em_atendimento' | 'encerrado' | 'perdido';

export const STATUS_CHAMADO: StatusChamado[] = ['aberto', 'encaminhado', 'em_atendimento', 'encerrado', 'perdido'];

export const STATUS_INFO: Record<StatusChamado, { label: string; bg: string; fg: string }> = {
  aberto: { label: 'ABERTO', bg: '#dbeafe', fg: '#1e3a8a' },
  encaminhado: { label: 'ENCAMINHADO', bg: '#fde68a', fg: '#000000' },
  em_atendimento: { label: 'EM ATENDIMENTO', bg: '#1e40af', fg: '#ffffff' },
  encerrado: { label: 'ENCERRADO', bg: '#e5e7eb', fg: '#4b5563' },
  perdido: { label: 'PERDIDO', bg: '#7c2d12', fg: '#ffffff' },
};

export function statusInfo(status: string | null | undefined): { label: string; bg: string; fg: string } {
  return STATUS_INFO[(status ?? 'aberto') as StatusChamado] ?? STATUS_INFO.aberto;
}
